export default __webpack_public_path__ + "static/media/allocateStudents2.0b30c920.png";